import { render, staticRenderFns } from "./MainTabPendingCustomerCodFeature.vue?vue&type=template&id=64a8949c&scoped=true"
import script from "./MainTabPendingCustomerCodFeature.vue?vue&type=script&lang=js"
export * from "./MainTabPendingCustomerCodFeature.vue?vue&type=script&lang=js"
import style0 from "./MainTabPendingCustomerCodFeature.vue?vue&type=style&index=0&id=64a8949c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8949c",
  null
  
)

export default component.exports